// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { ElementData, ElementsPlugin } from '../../../capacitor_plugins/elementActions';
import { createAndEditNewQuickNoteElement } from '../actions/quickNotesActions';

// Selectors
import { getCurrentUserQuickNotesRootBoardId } from '../../user/currentUserSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Types
import { ElementType } from '../../../common/elements/elementTypes';

// Constants
import { CAPACITOR_ELEMENT_ACTIONS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

const useAttachElements = () => {
    const dispatch = useDispatch();
    const platformDetails = useSelector(getPlatformDetailsSelector);
    const quicknotesBoardId = useSelector(getCurrentUserQuickNotesRootBoardId);

    const elementType = (type: string): ElementType => {
        switch (type) {
            case 'todo':
                return ElementType.TASK_LIST_TYPE;
            case 'image':
                return ElementType.IMAGE_TYPE;
            default:
                return ElementType.CARD_TYPE;
        }
    };

    useEffect(() => {
        if (!Capacitor.isPluginAvailable(CAPACITOR_ELEMENT_ACTIONS_PLUGIN)) return;

        ElementsPlugin.addListener('createNewQuicknotesElement', (data: ElementData) => {
            requestAnimationFrame(() => {
                const type = elementType(data.type.toLowerCase());

                dispatch(createAndEditNewQuickNoteElement(quicknotesBoardId, type, platformDetails));
            });
        });
    }, [quicknotesBoardId]);
};

export default useAttachElements;
